<div id="content">
  <div class="page-title d-flex justify-content-between align-items-center mb-4">
    <h1 class="mb-0">{{ page_title }}</h1>
  </div>

  @if (today_data(); as data) {
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <h2>Estado actual</h2>
          <div class="row row-cols-1 row-cols-md-3 row-cols-lg-6" style="margin: 0">
            @for (d of data; track d.id) {
              <div class="col" style="margin-bottom: 8px; padding: 0 4px">
                <div
                  style="
                    overflow-x: hidden;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                    border-radius: 6px;
                    padding: 6px 10px;
                    gap: 8px;
                    background: #f9f9f9;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                    font-size: 0.9rem;
                  "
                >
                  <div style="display: flex; gap: 4px; flex-shrink: 0">
                    @if (!d.vacation && !d.holiday && !d.absence && d.working && !d.rest) {
                      <span [matTooltip]="'Trabajando'" class="info-emoji" style="font-size: 1rem">🟢</span>
                    }
                    @if (!d.vacation && !d.holiday && !d.absence && d.rest) {
                      <span [matTooltip]="'Descanso'" class="info-emoji" style="font-size: 1rem">🔵</span>
                    }
                    @if (!d.vacation && !d.holiday && !d.absence && !d.working && !d.rest) {
                      <span [matTooltip]="'No trabajando'" class="info-emoji" style="font-size: 1rem">⚫️</span>
                    }
                    @if (isToday(d.birthday)) {
                      <span [matTooltip]="'Es su cumpleaños'" class="info-emoji" style="font-size: 1rem">🎂</span>
                    }
                    @if (d.vacation) {
                      <span [matTooltip]="'Vacaciones'" class="info-emoji" style="font-size: 1rem">🌴</span>
                    }
                    @if (d.holiday) {
                      <span [matTooltip]="'Festivo'" class="info-emoji" style="font-size: 1rem">🎆</span>
                    }
                    @if (!d.vacation && d.absence) {
                      <span
                        [matTooltip]="(d.absence_hours ?? null) !== null ? 'Ausencia (' + d.absence_hours + ')' : 'Ausencia'"
                        class="info-emoji"
                        style="font-size: 1rem"
                        >🪑</span
                      >
                    }
                    @if (d.remote_working && d.out_of_office) {
                      <span [matTooltip]="'Tiene teletrabajo'" class="info-emoji" style="font-size: 1rem">🏠</span>
                    }
                    @if (!d.remote_working && d.out_of_office) {
                      <span [matTooltip]="'No está en la oficina, y debería'" class="info-emoji" style="font-size: 1rem">
                        🏢<span class="suffix-info-emoji">❌</span>
                      </span>
                    }
                  </div>
                  <div [matTooltip]="d.working_hours" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                    {{ d.formatted_name }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (active_company_objectives_for_view().length > 0) {
    <div class="container-fluid mt-4 p-0">
      @for (objective of active_company_objectives_for_view(); track objective.id) {
        <div class="card mb-5">
          <app-company-product-objective [objective]="objective" />
        </div>
      }
    </div>
  }

  <div class="card">
    <app-vacations [show_admin_management]="false"></app-vacations>
  </div>
</div>
